module.exports = __webpack_public_path__ + "media/images/icon-file-b8eb5626f0d1fea9df99e3fd6a3599e7.png";